import { render, staticRenderFns } from "./StandardFormRow.vue?vue&type=template&id=8764c07e&scoped=true&"
import script from "./StandardFormRow.vue?vue&type=script&lang=js&"
export * from "./StandardFormRow.vue?vue&type=script&lang=js&"
import style0 from "./StandardFormRow.vue?vue&type=style&index=0&id=8764c07e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8764c07e",
  null
  
)

export default component.exports